import { Radio } from 'antd'
import clsx from 'clsx'
import { type FC } from 'react'

import {
  RECORDING_DATE_TYPE,
  RECORDING_DATE_TYPE_LABEL,
  type RecordingDateType
} from '@/libs/api/types'

type Props = {
  /** 選択中の計上基準。未選択（フォーム初期値で undefined）の場合は何も選択されない */
  value?: RecordingDateType
  onChange?: (value: RecordingDateType) => void
  disabled?: boolean
  className?: string
  /** ラジオグループに紐付ける外部ラベルの id（aria-labelledby）*/
  'aria-labelledby'?: string
}

// 表示順は時系列に揃える（発日 → 着日）。Object.values の宣言順依存を避けるため明示配列。
const ORDERED_TYPES = [
  RECORDING_DATE_TYPE.SHIPPING_DATE,
  RECORDING_DATE_TYPE.DELIVERY_DATE
] as const

const options = ORDERED_TYPES.map((type) => ({
  label: RECORDING_DATE_TYPE_LABEL[type],
  value: type
}))

/**
 * 計上基準（発日 / 着日）ラジオグループ。VOC_PJ-55 #3516。
 * IN_HOUSE Partner のデフォルト指定 / CONTRACTOR Partner の個別指定 / Customer の個別指定で使用。
 */
export const RecordingDateTypeRadioGroup: FC<Props> = ({
  value,
  onChange,
  disabled,
  className,
  'aria-labelledby': ariaLabelledBy
}) => {
  return (
    <div className={clsx(className)}>
      <Radio.Group
        value={value}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.value as RecordingDateType)}
        options={options}
        aria-labelledby={ariaLabelledBy}
      />
    </div>
  )
}
